import React, { useEffect } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import './LegalPage.css';

/**
 * LegalPage — shared layout for the Privacy Policy and Terms pages.
 * Driven by a structured `doc` object from data/legalContent.js.
 */
const LegalPage = ({ doc }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [doc]);

  return (
    <>
      <>
        <title>{`${doc.title} — ThirdRail Avenue`}</title>
        <meta name="description" content={`${doc.title} for ThirdRail Avenue.`} />
      </>

      <Navbar />

      <main id="main-content" className="legal">
        <div className="legal__container tra-container">
          <header className="legal__header">
            <h1 className="legal__title">{doc.title}</h1>
            <p className="legal__updated">Last updated: {doc.updated}</p>
          </header>

          {doc.intro && <p className="legal__intro">{doc.intro}</p>}

          {doc.sections.map((section) => (
            <section className="legal__section" key={section.heading}>
              <h2 className="legal__heading">{section.heading}</h2>
              {section.body &&
                section.body.map((para, i) => (
                  <p className="legal__text" key={i}>
                    {para}
                  </p>
                ))}
              {section.list && (
                <ul className="legal__list">
                  {section.list.map((li, i) => (
                    <li key={i}>{li}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </main>

      <Footer />
    </>
  );
};

export default LegalPage;
